import { z } from 'zod'
import type { WebDomain } from './Domain'

const ThemeColorsSchema = z.object({
  primary: z.string(),
  secondary: z.string(),
  accent: z.string(),
  error: z.string(),
  info: z.string(),
  success: z.string(),
  warning: z.string(),
  sidebar: z.string(),
  sidebar_secondary: z.string(),
})

const ApplicationThemeSchema = z.object({
  light: ThemeColorsSchema,
  dark: ThemeColorsSchema,
})

type ThemeColors = z.infer<typeof ThemeColorsSchema>
type ThemeColorsKey = keyof ThemeColors
type ApplicationTheme = z.infer<typeof ApplicationThemeSchema>
type ApplicationThemeKey = keyof ApplicationTheme

type ManifestFaviconSize = '16x16' | '32x32' | '71x72' | '96x96'
  | '120x120' | '128x128' | '144x144' | '152x152'
  | '180x180' | '192x192' | '384x384' | '512x512'
type ManifestFavicon = {
  src: string
  type: string
  purpose: string
  content: string
  sizes: ManifestFaviconSize
}
type ManifestWebDomain = WebDomain & {
  favicons: ManifestFavicon[]
  manifest: {
    id: string
    scope: string
    name: string
    short_name: string
    theme_color: string
    description: string
    dir: 'ltr'
    icons: ManifestFavicon[]
    start_url: string
    display: 'standalone'
    background_color: string
    prefer_related_applications: boolean
    manifestIconBase64: string | null
  }
}
const DEFAULT_MANIFEST: ManifestWebDomain = {
  id: null,
  name: '',
  loginLogo: '',
  sidebarLogo: '',
  favicons: [],
  routable: true,
  type: 'WEB',
  service: 'MANAGEMENT_TOOL',
  manifest: {
    id: '/',
    scope: '/',
    name: '',
    short_name: '',
    theme_color: '',
    description: '',
    dir: 'ltr',
    icons: [],
    start_url: '/',
    display: 'standalone',
    background_color: '',
    prefer_related_applications: false,
    manifestIconBase64: null,
  },
  theme: {
    dark: {
      accent: '#FF4081',
      error: '#FF5252',
      info: '#2196F3',
      primary: '#2196F3',
      secondary: '#6C757D',
      success: '#4CAF50',
      warning: '#FB8C00',
      sidebar: '#FFFFFF',
      sidebar_secondary: '#FFFFFF',
    },
    light: {
      accent: '#82B1FF',
      error: '#FF5252',
      info: '#2196F3',
      primary: '#1976D2',
      secondary: '#6C757D',
      success: '#4CAF50',
      warning: '#FB8C00',
      sidebar: '#000000de',
      sidebar_secondary: '#000000de',
    },
  },
}
export {
  ApplicationThemeSchema,
  DEFAULT_MANIFEST
}
export type {
  ApplicationTheme,
  ApplicationThemeKey,
  ThemeColorsKey,
  ManifestWebDomain
}
